import type { GQLError } from '../../resources';

export enum LifecycleState {
  Complete = 'Complete', // BE filters out for now, but FE is ready to handle
  Replaced = 'Replaced', // BE filters out for now, not handled by FE
  Rejected = 'Rejected',
  Scheduled = 'Scheduled',
  AppliedToPurchase = 'AppliedToPurchase',
  Expired = 'Expired',
  Active = 'Active',
  NeedsManualAppraisal = 'NeedsManualAppraisal',
  DeclinedReprice = 'DeclinedReprice' // BE filters out for now, but FE is ready to handle
}

export type VehicleSummary = {
  acquisitionName: string;
  appraisalId: string;
  color?: string;
  daysToExpiration?: number;
  expirationDate: string;
  // legacy support
  isDrivable?: boolean;
  isOfferAccepted: boolean;
  lifecycleState: LifecycleState;
  // True when the acquisition has been applied to a purchase as a trade-in
  // (set by the Acquisition ApplyToPurchase flow). Authoritative trade-in signal.
  isTradeIn?: boolean;
  make?: string;
  model?: string;
  trim?: string;
  // legacy support
  vehicleImages?: {
    mobileImage?: string;
  };
  vehicleValue: number;
  year?: number;
};

export type VehicleSummariesData = {
  vehicleSummaries: VehicleSummary[];
};

export type VehicleSummariesResponse = {
  data: VehicleSummariesData;
  errors?: GQLError[];
};

const buildVehicleSummariesQuery = (extraFields = '') => `
  query getVehicleSummaries {
    vehicleSummaries {
      acquisitionName
      appraisalId
      color
      daysToExpiration
      expirationDate
      isOfferAccepted
      lifecycleState${extraFields}
      make
      model
      trim
      vehicleValue
      year
    }
  }`;

const getVehicleSummariesQuery = buildVehicleSummariesQuery('\n      isTradeIn');

/**
 * Fallback query without `isTradeIn`, used when the BFF schema does not yet
 * expose the field (e.g. STC Home deployed ahead of the BFF change). Lets
 * summaries keep loading instead of erroring the whole hero. Safe to remove once
 * the BFF `isTradeIn` change is live in production.
 */
export const getVehicleSummariesLegacyQuery = buildVehicleSummariesQuery();

export default getVehicleSummariesQuery;
